import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';
import { MlmProviderId, MlmProviderStaticData } from '~/tenants/mlm/model/MlmProvider';

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone, addresses and pay live in ./providers.server.ts and are
 * merged into these same objects on the server (tenants/providers.server.ts).
 */
const MLM_PROVIDER_DATA_PUBLIC: Record<MlmProviderId, ProviderPublic<MlmProviderStaticData & ProviderStaticConfig>> = {
  [MlmProviderId.SOPHIA_BEDNARIK]: {
    first: 'Sophia',
    last: 'Bednarik',
    headshot: 'tenant/mlm/provider/sophia.png',
    location: 'sme',
    schedule: true,
    commercial: true,
    performable_floorplan: true,
    performable_aerialp: true,
    performable_aerialv: true,
  },
  [MlmProviderId.JACK_SANDONE]: {
    first: 'Jack',
    last: 'Sandone',
    headshot: 'tenant/mlm/provider/jack.jpg',
    location: 'sme',
    schedule: true,
    commercial: true,
    performable_walkthrough: true,
    performable_aerialp: true,
    performable_floorplan: true,
    performable_aerialv: true,
  },
  [MlmProviderId.MITCH_POWERS]: {
    first: 'Mitch',
    last: 'Powers',
    headshot: 'avatar.jpg',
    location: 'sme',
    schedule: true,
    commercial: true,
    performable_walkthrough: true,
    performable_aerialp: true,
    performable_aerialv: true,
  },
  [MlmProviderId.JACK_STEPP]: {
    first: 'Jack',
    last: 'Stepp',
    headshot: 'avatar.jpg',
    location: 'sme',
    schedule: true,
    performable_floorplan: true,
    performable_aerialp: true,
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const MLM_PROVIDER_DATA = MLM_PROVIDER_DATA_PUBLIC as Record<MlmProviderId, MlmProviderStaticData & ProviderStaticConfig>;
